export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/packaging_design.b2affea.svg";